export default class ListaDeChecagem {
  constructor() {
    this.id = "";
    this.descricao = "Nova Lista de Checagem";
    this.itens = this.getDefaultItens();
  }

  getDefaultItens() {
    let list = [];
    for (let index = 1; index < 14; index++) {
      list.push({
        item: "" + index,
        conjunto: "- - -",
        descricao: "- - -",
        laudo: true,
      });
    }
    return list;
  }
}
